import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';
import { Select } from '@/shared/ui/core';
import { SelectProps } from '@/shared/ui/core/select/model/select.types';


type ControlledSelectProps<T extends FieldValues> = Omit<SelectProps, 'value' | 'onValueChange' | 'defaultValue'> & {
    name: Path<T>;
}

export const ControlledSelect = <T extends FieldValues>({ name, ...props }: ControlledSelectProps<T>) => {
    const { control, formState: { errors }, clearErrors } = useFormContext<T>();

    return (
        <Controller
            control={ control }
            name={ name }
            render={ ({ field }) => (
                <Select
                    { ...props }
                    value={ field.value as string }
                    onValueChange={ (val) => {
                        field.onChange(val);
                        clearErrors(name);
                    } }
                    error={ errors[name]?.message as string | undefined }
                />
            ) }
        />
    );
};
